import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AnalyticsService } from '@geneplanet/ngx-utils';
import { take } from 'rxjs/operators';
import { LanguageService } from 'src/app/shared/services/language.service';
import { environment } from 'src/environments/environment';
import { GptLocalizationModule } from '@geneplanet/ngx-utils/src/lib/localization';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-header-language-switcher',
  templateUrl: './header-language-switcher.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [GptLocalizationModule, AsyncPipe],
})
export class HeaderLanguageSwitcherComponent {
  languageService = inject(LanguageService);
  private analyticsService = inject(AnalyticsService);

  environment = environment;

  locationChange(event: any) {
    this.languageService.onLocationChange(event);
    this.languageService.currentLocation$
      .pipe(take(1))
      .subscribe((location) => {
        const value = {
          value: location.lang.code + '/' + location.currency,
        };

        this.analyticsService.trackFormValue(
          'header-location-change',
          'location',
          value
        );
      });
  }
}
